/**
 * antd message/notification/modal 全局代理
 *
 * 解决静态 API 无法消费 Context 的问题：
 * 通过 AppContextBridge 将 App.useApp() 实例存储到此处，
 * 供 React 组件外代码与历史页面复用。
 */
import type { MessageInstance } from 'antd/es/message/interface';
import type { NotificationInstance } from 'antd/es/notification/interface';
import { message as staticMessage, notification as staticNotification, Modal as staticModal } from 'antd';

let _message: MessageInstance = staticMessage;
let _notification: NotificationInstance = staticNotification;
type ModalInstance = Pick<
  typeof staticModal,
  'info' | 'success' | 'error' | 'warning' | 'confirm' | 'destroyAll'
>;
let _modal: ModalInstance = staticModal;

export function setMessageInstance(instance: MessageInstance) {
  _message = instance;
}

export function setNotificationInstance(instance: NotificationInstance) {
  _notification = instance;
}

export function setModalInstance(instance: ModalInstance) {
  _modal = instance;
}

export const message: MessageInstance = new Proxy({} as MessageInstance, {
  get(_target, prop) {
    return (_message as any)[prop];
  },
});

export const notification: NotificationInstance = new Proxy({} as NotificationInstance, {
  get(_target, prop) {
    return (_notification as any)[prop];
  },
});

export const modal: ModalInstance = new Proxy({} as ModalInstance, {
  get(_target, prop) {
    return (_modal as any)[prop];
  },
});
